import React from "react";
import { HiOutlineLogout } from 'react-icons/hi';
import "./account.css";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { decryptUserInfo } from "../../../SharedFiles/decryption/Decryption";
import { logout } from "../../../APIServices/Login/loginSlice";

const Account = () => {
    const gifPath = "/User.gif";
    const navigate = useNavigate();
    const userData = sessionStorage.getItem('user');
    const dispatch = useDispatch();
    const parsedUserData = userData ? JSON.parse(userData) : null;
    const decryptedUserInfo = parsedUserData && decryptUserInfo(parsedUserData);
    const UserName = decryptedUserInfo && decryptedUserInfo[0].USERNAME;

    const handleLogout = async () => {
        // sessionStorage.removeItem('user'); 
        // sessionStorage.removeItem('cartItems'); 
        // sessionStorage.removeItem('userCate'); 
        // sessionStorage.removeItem('itemGroup'); 
        // sessionStorage.removeItem('itemGroupFlag'); 
        // sessionStorage.removeItem('activeIcon'); 
        dispatch(logout());
        navigate("/");
    };

    return (
        <div>
            <div className="accDiv">
                <div className="UserAcc">
                <img src={gifPath} alt="User Avatar" className="user-avatar-gif" />
                </div>
                <h3>{UserName}</h3>
            </div>
            <div className="accdatadiv">
                <button className="logout-btn dropdown-item mt-2 text-center rounded"
                    onClick={handleLogout}>Logout <HiOutlineLogout/></button>
            </div>
            <p className="footer-text mt-3 text-center">Powered by Workglow Solutions</p>
        </div>
    );
};

export default Account;